import PropTypes from "prop-types";

import {
  FormCombobox,
  FormDateTimePicker,
  FormInput,
  FormSelect,
  FormTextarea,
  SectionCard,
} from "components/BaseForm";
import { getUserTimeZone } from "components/helpers";

const DetailsSection = ({ statusOptions, userOptions, formOptions }) => {
  const timeZone = getUserTimeZone();

  return (
    <SectionCard title="Basic Information">
      <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
        <FormInput name="name" label="Name" required />
        <FormSelect
          name="status"
          label="Status"
          required
          options={statusOptions}
        />
        <FormCombobox
          name="assigned_user_id"
          label="Assignee"
          required
          options={userOptions}
        />
        <FormCombobox
          name="form_id"
          label="Form"
          clearable
          options={formOptions}
        />
        <FormDateTimePicker
          name="start_time"
          label="Start Time"
          required
          timeZone={timeZone}
        />
        <FormDateTimePicker
          name="end_time"
          label="End Time"
          timeZone={timeZone}
        />
        <FormTextarea
          name="description"
          label="Description"
          required
          rows={3}
          className="tw:sm:col-span-2"
        />
      </div>
    </SectionCard>
  );
};

DetailsSection.propTypes = {
  statusOptions: PropTypes.array.isRequired,
  userOptions: PropTypes.array.isRequired,
  formOptions: PropTypes.array.isRequired,
};

export default DetailsSection;
